<script>
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  function expandSetup() {
    dispatch("expandSetup");
  }
</script>

<div class="w-full flex justify-center items-center">
  <button
    title="Expand"
    on:click={expandSetup}
    aria-label="Expand"
    class="active:text-gray-400 cursor-pointer select-none focus:outline-none transform hover:scale-125 focus:scale-125 transition duration-200 ease-in-out rounded-full focus:bg-gray-300 focus:bg-opacity-30"
  >
    <svg class="h-8 w-8 fill-current" viewBox="0 0 20 20">
      <path
        fill-rule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
        clip-rule="evenodd"
      />
    </svg>
  </button>
</div>
